
import { statusList } from '@/utils/constants';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
@Component({ components: {} })
export default class StatusIcon extends Vue {
  statusType: string = 'available';
  statusName: string = '連絡可能';
  @Prop() private statusId!: string;
  @Prop() private itemSize!: string;
  @Prop() private showName!: boolean;

  get sizeStyle() {
    let size = this.itemSize ?? 12;
    return { width: size + 'px', height: size + 'px' };
  }
  get iconSizeStyle() {
    let size = Math.floor((+(this.itemSize || 12) * 12) / 21);
    return { width: size + 'px', height: size + 'px' };
  }

  @Watch('statusId')
  private onStatusIdChanged(): void {
    if (!this.statusId) {
      return;
    }
    let status = statusList.find((s) => s.id == this.statusId);
    if (status) {
      this.statusType = status.type;
      this.statusName = status.name;
    } else {
      this.statusType = 'offline';
      this.statusName = this.statusId;
    }
  }
  mounted() {
    this.onStatusIdChanged();
  }
}
